var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4888 6C13.8691 6 12.5562 7.3215 12.5562 8.95166V9.05344H9.42135H8.41011C7.90747 9.05344 7.5 9.46355 7.5 9.96947C7.5 10.4754 7.90747 10.8855 8.41011 10.8855H9.42135H9.73366L10.5683 23.3756L10.5685 23.3776C10.661 24.8518 11.876 26 13.3438 26H19.6562C21.124 26 22.3389 24.8518 22.4315 23.3777L22.4316 23.3756L23.2664 10.8855H23.5787H24.5899C25.0926 10.8855 25.5 10.4754 25.5 9.96947C25.5 9.46355 25.0926 9.05344 24.5899 9.05344H23.5787H20.4438V8.95166C20.4438 7.3215 19.1308 6 17.5112 6H15.4888ZM18.6236 9.05344H14.3764V8.95166C14.3764 8.33331 14.8744 7.83206 15.4888 7.83206H17.5112C18.1256 7.83206 18.6236 8.33331 18.6236 8.95166V9.05344ZM15.0835 14.0015C15.0619 13.496 14.6374 13.1039 14.1352 13.1255C13.633 13.1472 13.2434 13.5745 13.2649 14.0799L13.5682 21.2046C13.5898 21.71 14.0143 22.1023 14.5165 22.0806C15.0186 22.0589 15.4084 21.6317 15.3868 21.1262L15.0835 14.0015ZM19.7351 14.0799C19.7567 13.5745 19.367 13.1472 18.8648 13.1255C18.3626 13.1039 17.9381 13.496 17.9165 14.0015L17.6132 21.1262C17.5916 21.6317 17.9814 22.0589 18.4835 22.0806C18.9857 22.1023 19.4102 21.71 19.4318 21.2046L19.7351 14.0799Z",
    fill: "#555893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.436e24d5.svg";
export { ForwardRef as ReactComponent };